import api from './api'
import type { User, LoginCredentials, RegisterData, AuthResponse } from '@/types/auth'

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const formData = new FormData()
    formData.append('username', credentials.email)
    formData.append('password', credentials.password)
    
    const response = await api.post<{ access_token: string; token_type: string }>('/auth/login', formData)
    
    // Get user profile after login
    const userResponse = await api.get<User>('/auth/me', {
      headers: {
        Authorization: `Bearer ${response.data.access_token}`
      }
    })
    
    return {
      access_token: response.data.access_token,
      token_type: response.data.token_type,
      user: userResponse.data
    }
  },

  async register(data: RegisterData): Promise<User> {
    const response = await api.post<User>('/auth/register', data)
    return response.data
  },

  async getProfile(): Promise<User> {
    const response = await api.get<User>('/auth/me')
    return response.data
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },

  async refreshToken(): Promise<{ access_token: string; token_type: string }> {
    const response = await api.post<{ access_token: string; token_type: string }>('/auth/refresh')
    return response.data
  },

  async updateProfile(data: { full_name: string; email: string }): Promise<User> {
    const response = await api.put<User>('/auth/me', data)
    return response.data
  },

  async changePassword(data: { current_password: string; new_password: string }): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/change-password', data)
    return response.data
  }
}